import { useState } from "react";
import { SubcontractorOfferTrailer } from "./offer-trailer-subcontractor";
import { Divider } from "@mui/material";
import styled from "styled-components";
import { OfferViewContent } from "../../../client-views/offer-view/components/offer-view-content";
import { PricelistOffersGetByIdOffers } from "../../../../services/orders/pricelist-offers-get-by-id/types";
import { SubcontractorOfferViewContent } from "./offer-view-content-subcontractor";

interface SubcontractorOffersProps {
  index: number;
  id_oferta: string;
  oferta: PricelistOffersGetByIdOffers;
}

const SubcontractorOffers = ({
  id_oferta,
  index,
  oferta,
}: SubcontractorOffersProps) => {
  const [expanded, setExpanded] = useState<string | false>(false);
  return (
    <>
      <div key={`${id_oferta}`}>
        <SubcontractorOfferTrailer
          index={index}
          setExpanded={setExpanded}
          expanded={expanded}
          offer_id={id_oferta}
        />
        <OfferDetails isVisible={expanded === id_oferta}>
          <Divider sx={{ marginTop: "16px", marginBottom: "16px" }} />
          {oferta.oferty_podwykonawcy.map((subcontractorOffer: any) => (
            <div
              key={`${id_oferta}_${subcontractorOffer.id_magazyn}`}
              style={{ marginTop: "32px" }}
            >
              <SubcontractorOfferViewContent
                id_oferta_podwykonawcy={
                  subcontractorOffer.id_oferta_podwykonawcy
                }
                pozycje_oferty={subcontractorOffer.pozycjeOferty}
                oferta_id={oferta.id_oferta}
              />
            </div>
          ))}
        </OfferDetails>
      </div>
    </>
  );
};

export default SubcontractorOffers;
const OfferDetails = styled.div<{
  isVisible: boolean;
}>`
  background-color: #f2f2f2;
  display: ${(props: any) => (props.isVisible ? "box" : "none")};
  margin-top: ${(props: any) => (props.isVisible ? "-16px" : "none")};
  border: 2px solid #f2f2f2;
  border-top: none;
  padding: 20px 16px;
  margin-bottom: 30px;
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
  transition-duration: 4s;
  -webkit-transition-duration: 10s;
  transition-timing-function: linear;
  & .target {
    background-color: #f2f2f2;
  }
`;
